module.exports = __webpack_public_path__ + "static/media/expand-less-grey.cfb4fccd.svg";